import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AzureRoutingModule } from './azure-routing.module';
import { AzureComponent } from './azure.component';
import { AzureStep1Component } from './azure-step1/azure-step1.component';
import { AzureStep2Component } from './azure-step2/azure-step2.component';
import { AzureStep3Component } from './azure-step3/azure-step3.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [AzureComponent, AzureStep1Component, AzureStep2Component, AzureStep3Component],
  imports: [
    CommonModule,
    AzureRoutingModule,
    FormsModule,
    ChartsModule,
    NgxSpinnerModule
  ]
})
export class AzureModule { }
